import React from 'react'

export const IconJuro = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <rect width="24" height="24" rx="5" fill="#000000" />
    <path d="M13.875 7.75V14.7a2 2 0 0 1-2 2H9.5" stroke="#FFFFFF" strokeWidth="1.75" />
  </svg>
)
